import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import SwitchSelector from 'react-switch-selector';
import { showLoader, hideLoader } from '../../../components/store/common/slice';
import { useAccessToken } from '../../../components/common/hooks/useAccessToken';
import { isAdminSelector } from '../../../components/store/auth/selectors';
import { StyledReport } from '../../../components/managers/reports/report.styled';
import Search from '../../../components/images/search.svg';
import { ActiveCampaignWrapper, ActiveCampaignTabs } from './ActiveCampaign.styled';
import AptCampaignList from './AptCampaignList';

const ActiveCampaign = ({ match }) => {
    const { t } = useTranslation();
    const client = useAccessToken();
    const dispatch = useDispatch();
    const isAdmin = useSelector(isAdminSelector);
    const ltr = useSelector(state => state.common.ltrEnabled);
    const { buildingID } = match.params;

    const [filter, setFilter] = useState('');
    const [currentTab, setCurrentTab] = useState('activeCampaign');
    const [aptWithCampaignRecords, setAptWithCampaignRecords] = useState([]);
    const [aptOutOfCampaignRecords, setAptOutOfCampaignRecords] = useState([]);
    const [campaignInfo, setCampaignInfo] = useState({});
    const [totalTenants, setTotalTenants] = useState();

    const components = {
        activeCampaign: {
            component: AptCampaignList,
            props: {
                records: aptWithCampaignRecords,
                campaignInfo: campaignInfo,
                filter,
                withCampaign: true,
                buildingID: buildingID
            }
        },
        outOfCampaign: {
            component: AptCampaignList,
            props: {
                records: aptOutOfCampaignRecords,
                filter,
                withCampaign: false,
                buildingID: buildingID
            }
        }
    };
    const tabComponent = components[currentTab];

    useEffect(() => {
        if (!client) return;
        (async function () {
            dispatch(showLoader());
                const { aptsWithCampaign, aptsWithoutCampaign, autoCampaign } = await client.get(`/operations/auto-campaigns/building/${buildingID}/state`);
                setAptWithCampaignRecords(aptsWithCampaign);
                setAptOutOfCampaignRecords(aptsWithoutCampaign);
                setCampaignInfo(autoCampaign);
                setTotalTenants(aptsWithCampaign.length + aptsWithoutCampaign.length);
            dispatch(hideLoader());
        })();
    }, [client]);

    if (!isAdmin) return <div>{t('searchPayments.noAdminRights')}</div>;

    return (
        <ActiveCampaignWrapper>
            <h1 className='page-title text-only'>
                <span>{t('managerAutoCampaign.activeCampaign.pageTitle')}</span>
            </h1>
            <div className='top-panel'>
                <div className='top-panel-title'>
                    {t('managerAutoCampaign.activeCampaign.totalTenants')} <span className='total-num'>{totalTenants}</span>
                </div>
                <div className='top-panel-inside'>
                    <StyledReport className='report' ltr={ltr}>
                        <div className='report-wrap'>
                            <div className='report-top'>
                                <div className='report-top-start'>
                                    <div className="search">                     
                                        <input
                                            type="text"
                                            name="search"
                                            onChange={e => setFilter(e.target.value.toLowerCase())}
                                        />
                                        <img src={Search} alt={t('search.search')} />                    
                                    </div>                                      
                                </div>
                            </div>
                        </div>
                    </StyledReport>
                    <ActiveCampaignTabs className={currentTab === 'activeCampaign' ? 'active-selected' : ''}>
                        <SwitchSelector
                            initialSelectedIndex={2}
                            options={[
                                {
                                    label: t('managerAutoCampaign.activeCampaign.tabs.activeCampaign'),
                                    value: 'activeCampaign',
                                    selectedBackgroundColor: 'white',
                                },
                                {
                                    label: t('managerAutoCampaign.activeCampaign.tabs.outOfCampaign'),
                                    value: 'outOfCampaign',
                                    selectedBackgroundColor: 'white',
                                }
                            ]}
                            selectedFontColor='#6E74FF'
                            fontColor='#ffffff'
                            backgroundColor='linear-gradient(90deg, #6C90FF -0.23%, #8567FF 92.15%)'
                            onChange={e => setCurrentTab(e)}
                        />
                    </ActiveCampaignTabs>
                </div>
            </div>
            <tabComponent.component
                {...tabComponent.props}
            />
        </ActiveCampaignWrapper>
    );
};

export default ActiveCampaign;